import { autoinject, computedFrom } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import dateHelper from "helpers/dateHelper";
import { NotificationHelper } from "helpers/notification-helper";
import queryStringHelper from "helpers/queryStringHelper";
import { DispatchProjectTimeEntryService } from "services/dispatch-project-time-entry-service";
import dispatchService from "services/dispatchService";

@autoinject
export class DailyEntryHoursSummary {

    public dispatchProjectCode: string = "";
    public dispatchDate: Date = new Date();
    public list: any[] = [];
    public noDataText: string = "";
    public subscribeSelected: any;
    public hasSelectedEntries: boolean = false;

    constructor(private readonly i18n: I18N, private readonly notificationHelper: NotificationHelper, private readonly dispatchProjectTimeEntryService: DispatchProjectTimeEntryService) {
    }

    public reloadButton(): any {
        return;
    }

    public async activate(params: any): Promise<any> {
        this.dispatchDate = params.dailyEntryDate;
        this.dispatchProjectCode = params.dispatchProjectCode;

        await this.loadData(params.dispatchProjectCode, params.dailyEntryDate);
    }

    public async loadData(dispatchProjectCode: string, dispatchDate: Date): Promise<any> {
        const data: any[] = (await this.dispatchProjectTimeEntryService.GetProjectTimeEntriesSummary(dispatchProjectCode, dateHelper.formatDateToSend(dispatchDate))) || [];

        this.list = data.map((item: any) => {
            item.selected = false;
            return item;
        });
    }

    public selectAll(): void {
        this.list.forEach((item: any) => {
            if (!item.IsQuit && item.IsInProgress && !item.selected) {
                this.selectEntry(item);
            }
        });

    }

    public selectEntry(entry: any): void {
        entry.selected = !entry.selected;
        this.hasSelectedEntries = this.list.some((item: any) => item.selected);
    }

    public async leave(): Promise<void> {
        if (this.hasSelectedEntries) {
            const selectedIds = this.list.filter((item: any) => item.selected).map((item: any) => item.Projects[0].DispatchId);
            await dispatchService.setHasLeftDispatches(true, selectedIds);
            await this.loadData(this.dispatchProjectCode, this.dispatchDate);
            await this.reloadButton();
            this.hasSelectedEntries = false;
        }
    }

    public async deleteAllHours(): Promise<void> {
        const dateText: string = dateHelper.getFullTextDate(this.dispatchDate);

        const firstConfirmation: boolean = await this.notificationHelper.showConfirmation(this.i18n.tr("msg_DeleteAllHoursDailyEntryConfirmation1", { date: dateText }));
        if (!firstConfirmation) {
            return;
        }

        const secondConfirmation: boolean = await this.notificationHelper.showConfirmation(this.i18n.tr("msg_DeleteAllHoursDailyEntryConfirmation2"));
        if (!secondConfirmation) {
            return;
        }

        await this.dispatchProjectTimeEntryService.DeleteAllTimeEntriesForDailyEntry(this.dispatchProjectCode, dateHelper.formatDateToSend(this.dispatchDate));
        await this.loadData(this.dispatchProjectCode, this.dispatchDate);
        await this.reloadButton();
        this.hasSelectedEntries = false;
    }

}
